<template>

	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">TRC Couple Renewal</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						TRC Couple Renewal Form
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<inertia-head title="TRC Couple Renewal" />

		<div v-if="flash && flash.title" class="alert shadow m-3 border border-default bg-white alert-dismissible" :class="flash.title === 'Status Success' ? 'alert-success' : 'alert-danger'" role="alert">
			<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
			<h3 class="alert-heading fs-5 fw-bold mb-1">{{ flash.title }}</h3>
			<p class="mb-0">
				{{ flash.message }}
			</p>
		</div>

		<div class="block block-rounded">
			<div class="block-content bg-info-light text-center">
				<div class="h3 fw-bold mb-0">
					TRC COUPLE
				</div>
				<div class="fs-sm fw-semibold mb-3">
					Expiry: {{ member.addons_expiry }}
				</div>
				<div class="fs-sm fw-semibold mb-3">
					{{member.subscription}}
				</div>
			</div>

			<div class="block-content block-content-full block-content-sm">
				<form @submit.prevent="advanceRenew">
					<div class="row">
						<div class="col-md-6 mb-4">
							<h6 class="fw-semibold">
								Subscription
							</h6>
							<div v-if="form.errors.subscription" class="alert alert-danger">
								<p class="fw-semibold mb-0">{{ form.errors.subscription }}</p>
							</div>
							<div class="row">
								<div
									class="col-12"
									v-for="subscription in products"
									:key="subscription.prod_id"
								>
									<div class="form-check form-block mb-3">
										<input
											v-model="form.subscription"
											class="form-check-input"
											type="radio"
											:value="subscription.prod_id"
											:id="subscription.prod_id"
											name="subscription"
										/>
										<label class="form-check-label" :for="subscription.prod_id">
											<span class="d-flex align-items-center">
												<h6 class="fs-sm mb-0">
													{{ subscription.membership_type }}
												</h6>
												<span
													v-if="subscription.add_display"
													class="badge bg-warning ms-1"
												>
													{{ subscription.add_display }}
												</span>
											</span>
											<small>
												<span>&#8369;{{ subscription.amount }}</span>
											</small>
										</label>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 mb-4">
							<h6 class="fw-semibold">Choose Payment Method</h6>
							<div class="row">
								<div class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											value="CARD"
											id="card"
											name="mop"
										/>
										<label class="form-check-label" for="card">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/stripe-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="payment_available==true" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY'"
											id="dragonpay"
											name="mop"
										/>
										<label class="form-check-label" for="dragonpay">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/dragonpay.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="payment_available==true" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY-GCASH'"
											id="dragonpay_gcash"
											name="mop"
										/>
										<label class="form-check-label" for="dragonpay_gcash">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/gcash.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<!-- <div class="col-4">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'BROPAY'"
											id="bropay"
											name="mop"
										/>
										<label class="form-check-label" for="bropay">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/bropay-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div> -->
							</div>
							<div v-if="form.mop == 'CARD'">
								<div v-if="member.has_card">
									<div class="form-check form-switch mb-4">
										<input
											v-model="form.use_existing_card"
											class="form-check-input"
											type="checkbox"
											:value="true"
											id="example-switch-default1"
											name="example-switch-default1"
										/>
										<label class="form-check-label" for="example-switch-default1">
											Use existing card
										</label>
									</div>
									<div v-if="form.use_existing_card" class="mb-4">
										<p class="mb-0">
											<span class="fw-semibold">CARD:</span>
											<i>**** **** **** {{ member.card.last4 }}</i>
											<span class="badge bg-primary ms-2">{{ member.card.brand }}</span>
											<span>
												<button @click="deleteCCDetails" type="button" class="btn btn-xs btn-outline-danger ms-1" title="Delete My Credit Card Details"><i class="fa fa-trash"></i></button>
											</span>
										</p>
									</div>
								</div>
								<div v-if="!form.use_existing_card" class="form-group mb-4">
									<stripe @accept-token="acceptToken" ref="stripe" />
									<div v-if="form.errors.card" class="invalid-feedback d-block">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.card }}
									</div>
								</div>
							</div>
							<div class="mb-4 text-end space-x-1">
								<button
									class="btn btn-alt-primary"
									:disabled="
										form.processing ||
										!form.subscription ||
										(form.mop === 'CARD' &&
											!form.use_existing_card &&
											!form.token)
									"
								>
									
									<span v-if="!form.processing">Pay Now!</span>
									<span v-else>
										<div class="spinner-border spinner-border-sm text-dark" role="status" >
											<span class="sr-only mr-1">Please wait...</span>
										</div>
										<span class="mx-2">Please wait...</span>
									</span>
								</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>


		<modal ref="deleteCreditCardModal">
			<template #title>Delete Credit Card Details</template>
			<template #body>
				<p class="text-danger fw-bold">Are you sure you want to delete your card details?</p>
				<p class="text-danger fw-bold">Your membership will not auto-renew and you might lose some of your benefits.</p>
			</template>
			<template #footer>
				<button @click="confirmDeleteCC" type="button" class="btn btn-alt-danger" :disabled="formCC.processing">
					<div
						v-if="formCC.processing"
						class="spinner-border spinner-border-sm text-dark me-1"
						role="status"
					>
						<span class="sr-only">Loading...</span>
					</div>
					<i v-else class="fa fa-trash me-1"></i>
					<span>YES</span>
				</button>
				<button @click="deleteCreditCardModal.toggleModal" type="button" class="btn btn-alt-secondary">
					<i class="fa fa-times me-1"></i>NO
				</button>
			</template>
		</modal>

	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'
import Stripe from '../../../Shared/Components/Stripe'
import { watch, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster'

export default {
	layout: AuthLayout,
	props: {
		test: String,
		member: Object,
		products: Object,
		flash: Object,
		flash1: Object,
	},
	components: {
		Stripe,
	},
	setup(props) {
		const toast = createToaster();

		const payment_available = ref(true);

		const deleteCreditCardModal = ref(null);

		const form = useForm({
						subscription: null,
						mop: 'CARD',
						pmethod: null,
						pchannel: null,
						token: null,
						use_existing_card: props.member.has_card?true:false,
						action: 'renew',
						test 	: props.test
					})

		const formCC = useForm({

		})

		const deleteCCDetails = ()=>{
			deleteCreditCardModal.value.toggleModal();
		}

		const acceptToken = (token) => {
								form.token = token
							}

		const confirmDeleteCC = ()=>{
			formCC.post(route('member.post.cc-details'),{
				preserveScroll: true,
				only:['flash,member,products'],
				onSuccess: ()=>{
					deleteCreditCardModal.value.toggleModal();
					form.use_existing_card = false;
				}
			})
		}

		const advanceRenew = () => {
						form.post(route('member.trc-couple.post.renew'), {
							
						})
					}


		watch(
			() => form.mop,
			(mop) => {
				
				form.pmethod 	= null;
				form.pchannel 	= null;	

				if(mop=='CARD' && props.member.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(mop!='CARD')
				{
					form.token = null;

					if(mop=='DRAGONPAY-GCASH')
					{
						form.pmethod 	= 'GCASH';
						form.pchannel 	= 'GCSH';
					}

				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		watch(()=>form.subscription,(value)=>{
			let val = value.split('+');
			if(value && val[0].includes("1M") && this.test=='no')
			{
				form.mop = 'CARD';
				payment_available.value = false;

				form.pmethod 	= null;
				form.pchannel 	= null;	

			}else
			{
				payment_available.value = true;
			}
		})

		return {
			deleteCreditCardModal,
			toast,
			form,
			formCC,
			deleteCCDetails,
			confirmDeleteCC,
			advanceRenew,
			payment_available,
			acceptToken,
		}
	},
}
</script>
